var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"heading":_vm.$t('reset_password.heading').toString(),"text":_vm.$t('reset_password.text').toString()}},[_c('ResetPasswordForm',{on:{"reset":_vm.handleReset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }